import { Link } from "@tanstack/react-router";
import menImg from "@/assets/hero-men-cognac.jpg?w=640;1024;1400&format=webp&as=srcset";
import menImgFallback from "@/assets/hero-men-cognac.jpg?w=1024&format=jpg";
import womenImg from "@/assets/hero-women-atelier.jpg?w=640;1024;1400&format=webp&as=srcset";
import womenImgFallback from "@/assets/hero-women-atelier.jpg?w=1024&format=jpg";

/**
 * Twin full-bleed promotional banners — Shop Men / Shop Women.
 */
export function TwinBanners() {
  const items = [
    { to: "/men", label: "Men's\n", img: menImgFallback, webp: menImg, alt: "Men's leather collection" },
    { to: "/women", label: "Women's\n", img: womenImgFallback, webp: womenImg, alt: "Women's leather collection" },
  ] as const;

  return (
    <section aria-label="Shop by gender" className="bg-bone">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
        {items.map((it) => (
          <Link
            key={it.to}
            to={it.to}
            preload="intent"
            className="group relative block aspect-[4/5] md:aspect-[3/4] overflow-hidden bg-secondary"
          >
            <picture>
              <source
                type="image/webp"
                srcSet={it.webp}
                sizes="(min-width: 768px) 50vw, 100vw"
              />
              <img
                src={it.img}
                alt={it.alt}
                loading="lazy"
                decoding="async"
                width={1400}
                height={1750}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
              />
            </picture>
            <div className="absolute inset-0 bg-gradient-to-t from-ink/65 via-ink/10 to-transparent" />
            <div className="absolute bottom-10 left-10 md:bottom-14 md:left-14 text-bone">
              <h3 className="font-serif text-xl md:text-2xl font-light drop-shadow-[0_1px_8px_rgba(20,16,12,0.5)] text-slate-50 whitespace-pre-line">
                {it.label}
              </h3>
              <span className="mt-5 inline-block text-[11px] uppercase tracking-[0.32em] border-b border-bone/70 pb-1">
                Discover
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
